import type { SettingsContext } from '../models/settings-hub.model';

const SHOP_COUNTRY_KEY = 'general.address_country';

/** Rule: the shop is in the given country */
export const inCountry = (country: string) => ({ getPreference }: SettingsContext) => getPreference(SHOP_COUNTRY_KEY) === country;

/** Rule: the shop is not in the given country */
export const notInCountry = (country: string) => ({ getPreference }: SettingsContext) => getPreference(SHOP_COUNTRY_KEY) !== country;
